
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";

class GameMarkets extends Component {
    constructor (props) {
        super(props);
        this.state = {
            marketsFilter: "all"//indicates which market group select by default
        };
        this.setMarketsFilter = this.setMarketsFilter.bind(this);
    }

    setMarketsFilter (groupName) {
        return () => this.setState({marketsFilter: groupName});
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_, ownParams) => {
    return createSelector(
        [
            state => state.gameMarketsList[ownParams.selectorKey] && JSON.stringify((() => {
                return ["all"].concat(Object.keys(state.gameMarketsList[ownParams.selectorKey]));
            })())
        ],
        (marketsGroupsNames) => {
            return {
                marketsGroupsNames: marketsGroupsNames && JSON.parse(marketsGroupsNames)
            };
        });
};

GameMarkets.propTypes = {
    gameId: PropTypes.number,
    selectorKey: PropTypes.string
};

export default connect(mapStateToProps)(GameMarkets);